// currentPage, sorting, filters,report,data
const Mutations = Object.freeze({
	SET_REPORT:
		'reportBuilderModule/reportBuilder/reportDetails/reportPreview/SET_REPORT',
	SET_WORKBOOK:
		'reportBuilderModule/reportBuilder/reportDetails/reportPreview/SET_WORKBOOK',
	SET_DATA:
		'reportBuilderModule/reportBuilder/reportDetails/reportPreview/SET_DATA',
	SET_QUICK_FILTER:
		'reportBuilderModule/reportBuilder/reportDetails/reportPreview/SET_QUICK_FILTER',
	SET_ADVANCED_FILTER:
		'reportBuilderModule/reportBuilder/reportDetails/reportPreview/SET_ADVANCED_FILTER',
	SET_SORTING:
		'reportBuilderModule/reportBuilder/reportDetails/reportPreview/SET_SORTING',
	SET_ROWS_PER_PAGE:
		'reportBuilderModule/reportBuilder/reportDetails/reportPreview/SET_ROWS_PER_PAGE',
	SET_PAGE:
		'reportBuilderModule/reportBuilder/reportDetails/reportPreview/SET_PAGE',
	SET_LOADING:
		'reportBuilderModule/reportBuilder/reportDetails/reportPreview/SET_LOADING',
	SET_GRID_DATA:
		'reportBuilderModule/reportBuilder/reportDetails/reportPreview/SET_GRID_DATA',
	SET_TOTAL_COUNT:
		'reportBuilderModule/reportBuilder/reportDetails/reportPreview/SET_TOTAL_COUNT',

	SET_WORKBOOK_QUICKFILTERS:
		'reportBuilderModule/reportBuilder/reportDetails/reportPreview/SET_WORKBOOK_QUICKFILTERS',
	SET_WORKBOOK_ADVANCEDFILTERS:
		'reportBuilderModule/reportBuilder/reportDetails/reportPreview/SET_WORKBOOK_ADVANCEDFILTERS',
});

export const Actions = Object.freeze({
	CLEAR: 'reportBuilderModule/reportBuilder/reportDetails/reportPreview/CLEAR',
	LOAD_REPORT_BY_ID:
		'reportBuilderModule/reportBuilder/reportDetails/reportPreview/LOAD_REPORT_BY_ID',
	LOAD_REPORT:
		'reportBuilderModule/reportBuilder/reportDetails/reportPreview/LOAD_REPORT',
	LOAD_DATA_RAW:
		'reportBuilderModule/reportBuilder/reportDetails/reportPreview/LOAD_DATA_RAW',
	LOAD_DATA_CUSTOM:
		'reportBuilderModule/reportBuilder/reportDetails/reportPreview/LOAD_DATA_CUSTOM',
	UPDATE_ROWSPERPAGE:
		'reportBuilderModule/reportBuilder/reportDetails/reportPreview/UPDATE_ROWSPERPAGE',
	UPDATE_PAGE:
		'reportBuilderModule/reportBuilder/reportDetails/reportPreview/UPDATE_PAGE',
	UPDATE_QUICK_FILTER:
		'reportBuilderModule/reportBuilder/reportDetails/reportPreview/UPDATE_QUICK_FILTER',
	UPDATE_ADVANCED_FILTER:
		'reportBuilderModule/reportBuilder/reportDetails/reportPreview/UPDATE_ADVANCED_FILTER',
	EXPORT_CUSTOM_DATA:
		'reportBuilderModule/reportBuilder/reportDetails/reportPreview/EXPORT_CUSTOM_DATA',
});

export const Getters = Object.freeze({
	REPORT: 'reportBuilderModule/reportBuilder/reportDetails/reportPreview/REPORT',
	ROWSPERPAGE:
		'reportBuilderModule/reportBuilder/reportDetails/reportPreview/ROWSPERPAGE',
	LOADING:
		'reportBuilderModule/reportBuilder/reportDetails/reportPreview/LOADING',
	TOTALCOUNT:
		'reportBuilderModule/reportBuilder/reportDetails/reportPreview/TOTALCOUNT',
	PAGE: 'reportBuilderModule/reportBuilder/reportDetails/reportPreview/PAGE',
	REPORT_COLUMNS_CUSTOM:
		'reportBuilderModule/reportBuilder/reportDetails/reportPreview/REPORT_COLUMNS_CUSTOM',
	REPORT_COLUMNS_RAW:
		'reportBuilderModule/reportBuilder/reportDetails/reportPreview/REPORT_COLUMNS_RAW',
	DATA: 'reportBuilderModule/reportBuilder/reportDetails/reportPreview/DATA',
	QUICKFILTER:
		'reportBuilderModule/reportBuilder/reportDetails/reportPreview/QUICKFILTER',
	ADVANCEDFILTER:
		'reportBuilderModule/reportBuilder/reportDetails/reportPreview/ADVANCEDFILTER',
	SORTING:
		'reportBuilderModule/reportBuilder/reportDetails/reportPreview/SORTING',
});
import { GeneralActions } from '../../../../actions';
import { reportTypes } from '../../../../../enums/reportTypes';
import dataService from '../../../../../services/data/reportBuilderService';
import exportDataService from '../../../../../services/data/dataExportService';
import fileUtils from '../../../../../utils/fileUtils';
import { ExportMode } from '../../../../../enums/ExportMode';
import Snackbar from '../../../../../components/core/dialogs/snackbarMessage';
export default {
	state: {
		workbook: null,
		report: null,
		quickFilter: { FieldId: null, Value: '' },
		advancedFilter: { Operator: 1, Filters: [], FiltersCount: 0 },
		workbookQuickFilters: [],
		workbookAdvancedFilters: [],
		sorting: [],
		rowsPerPage: 50,
		page: 1,
		loading: false,
		data: [],
		totalCount: 0,
	},
	mutations: {
		[Mutations.SET_WORKBOOK](state, item) {
			state.workbook = item;
		},
		[Mutations.SET_REPORT](state, item) {
			state.report = item;
		},
		[Mutations.SET_QUICK_FILTER](state, item) {
			if (state.workbook) {
				if (state.workbook.IsSingleFilter) {
					state.quickFilter = item;
				} else {
					let index = state.workbookQuickFilters.findIndex(
						(filter) => filter.reportId === state.report.Id
					);
					if (index !== -1) {
						state.workbookQuickFilters[index] = {
							reportId: state.report.Id,
							quickFilter: item,
						};
					} else {
						state.workbookQuickFilters.push({
							reportId: state.report.Id,
							quickFilter: item,
						});
					}
				}
			} else {
				state.quickFilter = item;
			}
		},
		[Mutations.SET_ADVANCED_FILTER](state, item) {
			if (state.workbook) {
				if (state.workbook.IsSingleFilter) {
					state.advancedFilter = item;
					state.advancedFilter.FiltersCount = item.Filters.length;
				} else {
					let index = state.workbookAdvancedFilters.findIndex(
						(filter) => filter.reportId === state.report.Id
					);
					if (index !== -1) {
						item.FiltersCount = item.Filters.length;
						state.workbookAdvancedFilters[index] = {
							reportId: state.report.Id,
							advancedFilter: item,
						};
					} else {
						item.FiltersCount = item.Filters.length;
						state.workbookAdvancedFilters.push({
							reportId: state.report.Id,
							advancedFilter: item,
						});
					}
				}
			} else {
				state.advancedFilter = item;
				state.advancedFilter.FiltersCount = item.Filters.length;
			}
		},
		[Mutations.SET_SORTING](state, item) {
			state.sorting = item;
		},
		[Mutations.SET_ROWS_PER_PAGE](state, value) {
			state.rowsPerPage = value;
		},
		[Mutations.SET_PAGE](state, value) {
			state.page = value;
		},
		[Mutations.SET_LOADING](state, value) {
			state.loading = value;
		},
		[Mutations.SET_DATA](state, items) {
			state.data = items;
		},
		[Mutations.SET_TOTAL_COUNT](state, value) {
			state.totalCount = value;
		},

		[Mutations.SET_WORKBOOK_QUICKFILTERS](state, items) {
			state.workbookQuickFilters = items;
		},
		[Mutations.SET_WORKBOOK_ADVANCEDFILTERS](state, items) {
			state.workbookAdvancedFilters = items;
		},
	},
	actions: {
		[Actions.CLEAR]({ commit }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_TOTAL_COUNT, 0);
				commit(Mutations.SET_PAGE, 1);
				commit(Mutations.SET_ROWS_PER_PAGE, 50);
				commit(Mutations.SET_LOADING, false);
				commit(Mutations.SET_SORTING, []);
				commit(Mutations.SET_ADVANCED_FILTER, {
					Operator: 1,
					Filters: [],
					FiltersCount: 0,
				});
				commit(Mutations.SET_QUICK_FILTER, {
					FieldId: null,
					Value: '',
				});
				commit(Mutations.SET_DATA, []);
				commit(Mutations.SET_REPORT, null);
				commit(Mutations.SET_WORKBOOK_QUICKFILTERS, []);
				commit(Mutations.SET_WORKBOOK_ADVANCEDFILTERS, []);
				commit(Mutations.SET_WORKBOOK, null);
				resolve();
			});
		},
		[Actions.LOAD_REPORT_BY_ID]({ commit, dispatch }, reportId) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getReport(reportId)
					.then((resp) => {
						commit(Mutations.SET_REPORT, resp.data);
						let sorting = [];
						resp.data.Sortings.sort(
							(a, b) => a.Order - b.Order
						).forEach((s) =>
							sorting.push({
								FieldId: resp.data.Fields.find(
									(f) => f.Id == s.ReportFieldId
								).GridViewFieldId,
								Operator: s.Operator,
							})
						);
						commit(Mutations.SET_SORTING, sorting);
						resolve(resp.data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(null);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.LOAD_REPORT]({ commit, dispatch }, payload) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				let report = payload.report;
				let workbook = payload.workbook;
				commit(Mutations.SET_WORKBOOK, workbook);
				commit(Mutations.SET_REPORT, report);
				let sorting = [];
				if (report)
					report.Sortings.sort((a, b) => a.Order - b.Order).forEach(
						(s) =>
							sorting.push({
								FieldId: report.Fields.find(
									(f) => f.Id == s.ReportFieldId
								).GridViewFieldId,
								Operator: s.Operator,
							})
					);
				commit(Mutations.SET_SORTING, sorting);
				dispatch(GeneralActions.LOADING, false);
				resolve(report);
			});
		},
		[Actions.UPDATE_PAGE]({ commit, dispatch }, page) {
			commit(Mutations.SET_PAGE, page);
			dispatch(Actions.LOAD_DATA_RAW);
		},

		[Actions.UPDATE_ROWSPERPAGE]({ commit, dispatch }, rowsPerPage) {
			commit(Mutations.SET_ROWS_PER_PAGE, rowsPerPage);
			dispatch(Actions.LOAD_DATA_RAW);
		},

		[Actions.LOAD_DATA_RAW]({ commit, dispatch, state }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_LOADING, true);
				let payload = {
					ReportId: state.report.Id,
					RowsPerPage: state.rowsPerPage,
					Page: state.page,
					AdvancedFilter: state.advancedFilter,
					QuickFilter: state.quickFilter,
					Sorting: state.sorting,
					IncludeCount: true,
				};
				dataService
					.reportPreview(payload)
					.then((resp) => {
						commit(Mutations.SET_TOTAL_COUNT, resp.data.Count);
						commit(Mutations.SET_DATA, resp.data.Data);
						resolve(resp.data.Data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(null);
					})
					.finally(() => {
						commit(Mutations.SET_LOADING, false);
					});
			});
		},
		[Actions.LOAD_DATA_CUSTOM]({ commit, dispatch, state }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_LOADING, true);
				let payload = {
					ReportId: state.report.Id,
					RowsPerPage: state.rowsPerPage,
					Page: state.page,
					IncludeCount: true,
				};
				dataService
					.reportPreview(payload)
					.then((resp) => {
						commit(Mutations.SET_TOTAL_COUNT, resp.data.Count);
						commit(Mutations.SET_DATA, resp.data.Data);
						resolve(resp.data.Data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(null);
					})
					.finally(() => {
						commit(Mutations.SET_LOADING, false);
					});
			});
		},
		[Actions.UPDATE_QUICK_FILTER]({ commit, dispatch }, quickFilter) {
			commit(Mutations.SET_QUICK_FILTER, quickFilter);
			dispatch(Actions.LOAD_DATA_RAW);
		},
		[Actions.UPDATE_ADVANCED_FILTER]({ commit, dispatch }, advancedFilter) {
			commit(Mutations.SET_ADVANCED_FILTER, advancedFilter);
			dispatch(Actions.LOAD_DATA_RAW);
		},
		[Actions.EXPORT_CUSTOM_DATA](
			{ dispatch, state },
			{ allData, isDirectMode = ExportMode.DIRECT }
		) {
			dispatch(GeneralActions.LOADING, true);
			return new Promise((resolve) => {
				if (!state.report) resolve(null);
				let payload = {
					ReportId: state.report.Id,
					ReportName: state.report.Name,
					RowsPerPage: allData ? state.totalCount : state.rowsPerPage,
					Page: allData ? 1 : state.page,
				};

				if (isDirectMode) {
					// Direct export mode - immediate download
					exportDataService
						.downloadReportDirect(payload)
						.then((resp) => {
							const serverFilename =
								fileUtils.extractFileNameFromResponse(resp);
							const filename =
								serverFilename ||
								`Report_${state.report.Name}_${new Date()
									.toISOString()
									.slice(0, 19)
									.replace(/:/g, '-')}.xlsx`;

							const blob = new Blob([resp.data], {
								type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
							});
							const url = window.URL.createObjectURL(blob);
							const link = document.createElement('a');
							link.href = url;
							link.setAttribute('download', filename);
							document.body.appendChild(link);
							link.click();
							document.body.removeChild(link);
							window.URL.revokeObjectURL(url);

							resolve(true);
						})
						.catch((error) => {
							dispatch(GeneralActions.ERROR, error);
							resolve(null);
						})
						.finally(() => {
							dispatch(GeneralActions.LOADING, false);
						});
				} else {
					// Background export mode - with notification
					exportDataService
						.downloadReportBackground(payload)
						.then(() => {
							Snackbar({
								message:
									'Export request registered. You will receive a notification when the file is ready for download!',
							});
							resolve(true);
						})
						.catch((error) => {
							dispatch(GeneralActions.ERROR, error);
							resolve(null);
						})
						.finally(() => {
							dispatch(GeneralActions.LOADING, false);
						});
				}
			});
		},
	},
	getters: {
		[Getters.REPORT_COLUMNS_RAW]: (state) => {
			if (!state.report) return [];
			if (
				state.report.Type &&
				state.report.Type == reportTypes.CUSTOM_DATA
			)
				return [];
			if (!state.report.GridView) return [];
			if (!state.report.GridView.Columns) return [];
			if (!state.report.Fields) return [];
			let result = [];
			state.report.Fields.sort((a, b) => a.Order - b.Order).forEach(
				(f) => {
					let item = state.report.GridView.Columns.find(
						(c) => c.Id == f.GridViewFieldId
					);
					if (item) {
						f.GridViewField = item;
						if (item.DataField) {
							f.DataField = item.DataField;
						}
						result.push(f);
					}
				}
			);
			return JSON.parse(JSON.stringify(result));
		},

		[Getters.REPORT_COLUMNS_CUSTOM]: (state) => {
			if (!state.report) return [];
			if (state.report.Type && state.report.Type == reportTypes.RAW_DATA)
				return [];
			if (!state.report.Fields) return [];

			let result = state.report.Fields.sort(
				(a, b) => a.Order - b.Order
			).map((f) => ({ Id: f.Id, Header: f.Label, FieldName: f.Source }));
			return result;
		},
		[Getters.DATA]: (state) => {
			if (!state.data.length > 0) return [];
			return JSON.parse(JSON.stringify(state.data));
		},
		[Getters.ROWSPERPAGE]: (state) => {
			return state.rowsPerPage;
		},
		[Getters.REPORT]: (state) => {
			return state.report;
		},
		[Getters.TOTALCOUNT]: (state) => {
			return state.totalCount;
		},
		[Getters.PAGE]: (state) => {
			return state.page;
		},
		[Getters.LOADING]: (state) => {
			return state.loading;
		},
		[Getters.QUICKFILTER]: (state) => {
			if (state.workbook && state.workbook.IsSingleFilter == false) {
				let result = state.workbookQuickFilters.find(
					(x) => x.reportId == state.report.Id
				);
				if (!result) {
					return { FieldId: null, Value: '' };
				}
				return result.quickFilter;
			}
			return state.quickFilter;
		},
		[Getters.ADVANCEDFILTER]: (state) => {
			if (state.workbook && state.workbook.IsSingleFilter == false) {
				let result = state.workbookAdvancedFilters.find(
					(x) => x.reportId == state.report.Id
				);
				if (!result) {
					return { Operator: 1, Filters: [], FiltersCount: 0 };
				}
				return result.advancedFilter;
			}
			return state.advancedFilter;
		},
		[Getters.SORTING]: (state) => {
			return state.sorting;
		},
	},
};
